import React from 'react';
import Leaves_Remuniration from './Leaves_Remuniration';
import '../../../CommonCSS/SocietyCSS.css'

const Leaves_RemunirationApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Add - Leaves & Remuneration </h5>
          </div>  
        </div>
        <Leaves_Remuniration/>
      </div>
    </div >
  );
};

export default Leaves_RemunirationApp;
